import { css } from '@emotion/css';

export const backdropStyle = css`
  background: rgba(0, 0, 0, 0.65);
`;

export const videoStyles = css`
  video,
  .plyr-container {
    width: 100%;
    height: 100%;
    min-width: 100%;
    min-height: 100%;
  }

  .plyr {
    width: 100%;
    height: 100%;
    border-radius: 0.8rem;
  }
`;

export const getHeight = (height: number) => css`
  height: ${height}rem;
`;
